import { action } from 'typesafe-actions';

import { IOpenApiInfo } from 'APIPackage/MainModule/interfaces/IOpenApiInfo';
import { IKnmPreview } from 'APIPackage/KnmSearchModule/interfaces/IKnmPreview';

import { KnmPreviewActionsEnum } from '../enums/KnmPreviewActionsEnum';

export const knmPreviewInitPage = (id: string) => action(KnmPreviewActionsEnum.KNM_PREVIEW_INIT_PAGE, { id });
export const knmPreviewSetOpenApiInfo = (openApiInfo: IOpenApiInfo) =>
  action(KnmPreviewActionsEnum.KNM_PREVIEW_SET_OPEN_API_INFO, { openApiInfo });
export const knmPreviewSetPassportData = (passportData?: IKnmPreview) =>
  action(KnmPreviewActionsEnum.KNM_PREVIEW_SET_PASSPORT_DATA, { passportData });
export const knmPreviewDownloadPassportPdf = () => action(KnmPreviewActionsEnum.KNM_PREVIEW_DOWNLOAD_PASSPORT_PDF);
